/* eslint-disable */

import React from 'react'
import { withStyles } from '@aura/components/styles'
import { Paper } from '@aura/components'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import styles from './styles'


const Component = ({
    classes,
    step
}) => {

    const { t: translate, i18n } = useTranslation()
    const isFrench = i18n.language === 'fr'


    return (<div className={`${classes.registrationBarContainer} ${isFrench ? classes.frenchLayout : ''}`}>
        <Paper className={ `${classes.stepPaper} ${classes.stepFirst}`}>
        {step > 2 ? <CheckCircleIcon className={classes.completed} /> : <div className={classes.stepNumber}>1</div> }
        <span className={classes.stepText}>{translate('registrationWelcome.card1Title')}</span>
        <div className={classes.linearBar}></div>
        </Paper>
        <Paper className={classes.stepPaper}>
            {step > 3 ? <CheckCircleIcon className={classes.completed} /> : <div className={`${classes.stepNumber} ${step <= 2 && classes.stepNumberDisabled}`}>2</div>}
        
        <span className={classes.stepText}>{translate('registrationWelcome.card2Title')}</span>
        <div className={classes.linearBar}></div>
        </Paper>
        <Paper className={`${classes.stepPaper} ${classes.stepPaperThird}`}>
        <div className={`${classes.stepNumber} ${step < 4 && classes.stepNumberDisabled}`}>3</div>
        <span className={classes.stepText}>{translate('registrationFlow.mfa')}</span>
        </Paper>
    </div>)
}

Component.displayName = 'SignIn'

Component.defaultProps = {
    data: {
        myApps: []
    }
}

Component.propTypes = {
    classes: PropTypes.shape({
        button: PropTypes.object,
        buttonContainer: PropTypes.object,
        fieldsContainer: PropTypes.object,
        signIntoApps: PropTypes.object
    }),
    data: PropTypes.object.isRequired,
    initUserApps: PropTypes.func.isRequired,
    userAppsStatus: PropTypes.string
}

export default withStyles(Component,styles)
